import React, { useMemo } from 'react';
import Icon, { COLORS } from '../icon';
import { AllChips } from '../../types/stylepacks';
import { useSelector } from 'react-redux';
import { GreenroomState } from '../../../stores/types/types';


interface GRInputProps {
	dataKey: string;
}

export default function ChipInputFiller(props: GRInputProps) {
	const {dataKey} = props;
	const chipMap = useSelector((s: GreenroomState) => s.ContentChipsReducer.chipMap);

	const type = chipMap.get(dataKey)?.chip_type ?? '';
	const chip = useMemo(() => AllChips.find((c) => c.type === type), [type]);


	if (!chip) return <></>
	return <div className="gr-input-chip static">
		<Icon name={chip.icon} size={12} color={COLORS.WHITE}/>
		<span className='bl-font-l3 text-container'>{chip.label}</span>
	</div> 
}
